import { ThemeOptions, alpha, createTheme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { deepmerge } from '@mui/utils';
import { validateTouchEnabled } from './utils/validators';

import type {} from '@mui/x-date-pickers/themeAugmentation';
import type {} from '@mui/x-tree-view/themeAugmentation';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoChipGreyBackground = '#d6d6d6';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGrayFont = '#8B8D8E';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSecondaryLight = '#6683FF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const inputFieldBackgroundGrayColor = '#E8E8E8';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoInfoIconGray = '#BDBEBF';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGrayChart = '#666666';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoDarkGray = '#757575';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoLightGray = '#CBCCCD';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoLightGrayButtonBackground = '#F8F8F8';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoLightGrayTooltipBackground = '#F6F6F6';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGrayHoveredBackground = '#e5e5e5';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoLightGrayInputBackground = '#F2F2F2';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGrayButton = '#F5F5F5';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoDarkGrayButton = '#5B5B5B';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const tableParentRow = '#FAFAFA';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const addProductBackgroundColor = '#FAFAFA';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGreen = '#00DAAD';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGreenDark = '#0dbc96';

const textDisabled = '#00000026';
const divider = '#E0E0E0';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoBlue = '#3366FF';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoBlueBackground = '#3F79FA';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoBluePreOrderTag = '#DEE7FF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoOrange = '#FF703D';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoOrangeBackGround = '#FF703D33';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoOrangeLightBackGround = '#FE6F3D0D';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoNotificationSnackbar = '#E0E0E0';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoBackgroundHighlightGrid = '#FFF9F7';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoOrangeSelectedRow = '#FFF4EF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoOrangeSelectedRowHover = '#FFEAE2';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoOrangeReadyToDeliveryTag = '#FFE2D8';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoBlackListTooltip = '#393939';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSignatureFontFamily = 'Satisfy, Nunito, sans-serif';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoFontFamily = 'Nunito, sans-serif';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const secondaryTeceoFontFamily = 'Open Sans, sans-serif';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSecondaryMain = '#3366FF';
const secondaryLight = '#3366FF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSecondaryDark = '#0048FC';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSecondaryContrast = '#FFFFFF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoPrimaryMain = '#FC6B4B';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoPrimaryLight = '#FF8A61';

const primaryLight = '#FC6B4B';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoPrimaryDark = '#FF5818';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoPrimaryContrast = '#FFFFFF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGrayPrimary = '#242424';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGraySecondary = '#97999B';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoTextDisabled = '#00000061';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoErrorMain = '#D32F2F';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoErrorDark = '#C62828';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoErrorLight = '#EF5350';
const errorLight = '#C62828';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoWarningMain = '#ED6C02';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoWarningDark = '#E65100';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoWarningLight = '#FF9800';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoWarningContrast = '#FFFFFF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoInfoMain = '#0288D1';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoInfoDark = '#01579B';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoInfoLight = '#03A9F4';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoInfoContrast = '#FFFFFF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSuccessMain = '#2E7D32';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSuccessDark = '#1B5E20';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSuccessLight = '#4CAF50';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSuccessContrast = '#FFFFFF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoGrayBackground = '#FAFAFA';
/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoPaperElevation0 = '#FFFFFF';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const fontWeightBold = 600;

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const paperBorderRadius = 16;

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const DIVIDER_BORDER_COLOR = '#0000001A';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoSummaryRowBackground = '#F8F8F8';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoActionButtonColor = '#707070';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const teceoDarkGrayBackground = '#424242';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const tertiaryMain = '#00CBA1';

/** @deprecated Use tokens semânticos do MUI ao invés de importar de Theme.tsx. */
export const customColors = {
  divider,
  black: '#242424',
  outlineborder: '#FC6B4B80',
  'text disabled': textDisabled,
  'error light': errorLight,
  'primary light': primaryLight,
  'error light 10%': `${errorLight}1A`,
  'primary light 5%': `${primaryLight}0D`,
  'primary light 10%': `${primaryLight}1A`,
  'primary light 20%': `${primaryLight}33`,
  'secondary light': secondaryLight,
  'secondary light 5%': `${secondaryLight}0D`,
  'secondary light 10%': `${secondaryLight}1A`,
  'secondary light 20%': `${secondaryLight}33`,
  'tertiary main': tertiaryMain,
  'tertiary dark': '#00A482',
  'tertiary light 5%': `${tertiaryMain}0D`,
  'tertiary light 10%': `${tertiaryMain}1A`,
  'tertiary light 20%': `${tertiaryMain}33`,
  'action active': '#97999B',
};

export const isTouchEnabled = validateTouchEnabled();

const defaultTheme = createTheme({
  palette: {
    default: {
      ...grey,
      main: grey[300],
      dark: grey[400],
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const mergedTheme = deepmerge(defaultTheme, {
  mixins: {},
  typography: {
    fontFamily: teceoFontFamily,
    fontWeightBold: 600,
    h1: {
      fontFamily: teceoFontFamily,
      fontSize: '96px',
      fontWeight: 300,
      lineHeight: 1.167,
      letterSpacing: '-1.5px',
    },
    h2: {
      fontFamily: teceoFontFamily,
      fontSize: '34px',
      fontWeight: 400,
      lineHeight: 0.847,
      letterSpacing: '0.25px',
    },
    h3: {
      fontFamily: teceoFontFamily,
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: teceoFontFamily,
      fontSize: '22px',
      fontWeight: 400,
      lineHeight: 1.2,
      letterSpacing: '0.25px',
    },
    h5: {
      fontFamily: teceoFontFamily,
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.3,
    },
    h6: {
      fontFamily: teceoFontFamily,
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: '0.25px',
    },
    subtitle1: {
      fontFamily: teceoFontFamily,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1.1,
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontFamily: secondaryTeceoFontFamily,
      fontSize: '12px',
      fontWeight: 300,
      lineHeight: 1.2,
      letterSpacing: '1px',
      textTransform: 'uppercase',
    },
    body1: {
      fontFamily: teceoFontFamily,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.1,
      letterSpacing: '0.25px',
    },
    body2: {
      fontFamily: teceoFontFamily,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 1.43,
      letterSpacing: '0.17px',
    },
    caption: {
      fontFamily: teceoFontFamily,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: '0.4px',
    },
    overline: {
      fontFamily: secondaryTeceoFontFamily,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 2.66,
      letterSpacing: '1px',
      textTransform: 'uppercase',
    },
    button: {
      fontFamily: teceoFontFamily,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: '#E0E0E0',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        circle: {
          strokeLinecap: 'round',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        filled: {
          padding: 15,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        bar: {
          strokeLinecap: 'round',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginLeft: 0,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          textTransform: 'lowercase',
          fontFamily: teceoFontFamily,
        },
        primary: {
          backgroundColor: teceoPrimaryMain,
          color: teceoPrimaryContrast,
        },
        secondary: {
          backgroundColor: teceoSecondaryMain,
          color: teceoSecondaryContrast,
        },
        sizeSmall: {
          padding: '4px 12px',
          borderRadius: '16px',
        },
        sizeMedium: {
          padding: '6px 16px 6px 16px',
          borderRadius: '20px',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        color: 'default',
      },
      variants: [
        {
          props: { variant: 'contained', color: 'default' },
          style: {
            color: teceoGraySecondary,
            backgroundColor: '#e0e0e0',
            '&:hover': {
              backgroundColor: defaultTheme.palette.grey[400],
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'default' },
          style: {
            color: teceoGraySecondary,
            borderColor:
              defaultTheme.palette.mode === 'light'
                ? 'rgba(0, 0, 0, 0.23)'
                : 'rgba(255, 255, 255, 0.23)',
            '&.Mui-disabled': {
              border: `1px solid ${defaultTheme.palette.action.disabledBackground}`,
            },
            '&:hover': {
              borderColor:
                defaultTheme.palette.mode === 'light'
                  ? 'rgba(0, 0, 0, 0.23)'
                  : 'rgba(255, 255, 255, 0.23)',
              backgroundColor: alpha(
                defaultTheme.palette.text.primary,
                defaultTheme.palette.action.hoverOpacity,
              ),
            },
          },
        },
        {
          props: { color: 'default', variant: 'text' },
          style: {
            color: teceoGraySecondary,
            '&:hover': {
              backgroundColor: alpha(
                defaultTheme.palette.text.primary,
                defaultTheme.palette.action.hoverOpacity,
              ),
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            color: teceoPrimaryMain,
            borderColor: '#FF703D80',
            '&:hover': {
              borderColor: teceoPrimaryMain,
              backgroundColor: alpha(teceoPrimaryMain, defaultTheme.palette.action.hoverOpacity),
            },
          },
        },
        {
          props: { variant: 'outlined', color: 'secondary' },
          style: {
            color: teceoSecondaryMain,
            borderColor: '#9C27B080',
            '&:hover': {
              borderColor: teceoSecondaryMain,
              backgroundColor: alpha(teceoSecondaryMain, defaultTheme.palette.action.hoverOpacity),
            },
          },
        },
        {
          props: { variant: 'contained', color: 'primary' },
          style: {
            color: teceoPrimaryContrast,
          },
        },
        {
          props: { variant: 'contained', color: 'secondary' },
          style: {
            color: teceoSecondaryContrast,
          },
        },
        {
          props: { variant: 'text', color: 'primary' },
          style: {
            color: teceoPrimaryMain,
            '&:hover': {
              backgroundColor: alpha(teceoPrimaryMain, defaultTheme.palette.action.hoverOpacity),
            },
          },
        },
        {
          props: { variant: 'text', color: 'secondary' },
          style: {
            color: teceoSecondaryMain,
            '&:hover': {
              backgroundColor: alpha(teceoSecondaryMain, defaultTheme.palette.action.hoverOpacity),
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          '@media (min-width:0px) and (max-width:599.95px)': {
            height: '38px',
          },
          borderRadius: '20px',
          textTransform: 'lowercase',
          color: teceoGraySecondary,
          borderColor: teceoGraySecondary,
          boxShadow: 'none !important',
          padding: '6px 16px',
          fontFamily: teceoFontFamily,
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '16px',
          letterSpacing: '0.4px',
          '&:hover': {
            boxShadow: 'none !important',
          },
        },
        contained: {
          color: teceoGraySecondary,
          fontFamily: teceoFontFamily,
          textTransform: 'lowercase',
        },
        containedPrimary: {
          color: teceoPrimaryContrast,
        },
        containedSecondary: {
          color: teceoSecondaryContrast,
        },
        containedSizeSmall: {
          padding: '5px 12px',
          borderRadius: '16px',
          fontSize: '13px',
          fontWeight: 600,
          lineHeight: '22px',
          letterSpacing: '0.46px',
        },
        containedSizeLarge: {
          padding: '7px 16px',
          fontSize: '15px',
          fontWeight: 600,
          lineHeight: '26px',
          letterSpacing: '0.46px',
        },
        outlined: {
          fontFamily: teceoFontFamily,
          textTransform: 'lowercase',
          borderWidth: '1px',
          borderStyle: 'solid',
          backgroundColor: 'transparent',
        },
        outlinedPrimary: {
          color: teceoPrimaryMain,
          borderColor: '#FF703D80',
        },
        outlinedSecondary: {
          color: teceoSecondaryMain,
          borderColor: '#9C27B080',
        },
        outlinedSizeSmall: {
          padding: '4px 12px',
          borderRadius: '16px',
          fontSize: '13px',
          fontWeight: 600,
          lineHeight: '22px',
          letterSpacing: '0.46px',
        },
        outlinedSizeLarge: {
          padding: '6px 16px',
          borderRadius: '32px',
          fontSize: '15px',
          fontWeight: 600,
          lineHeight: '26px',
          letterSpacing: '0.46px',
        },
        text: {
          textTransform: 'lowercase',
          fontFamily: teceoFontFamily,
          backgroundColor: 'transparent',
          color: teceoGraySecondary,
          padding: '6px 8px',
        },
        textPrimary: {
          color: teceoPrimaryMain,
        },
        textSecondary: {
          color: teceoSecondaryMain,
        },
        textSizeSmall: {
          fontSize: '13px',
          fontWeight: 600,
          lineHeight: '22px',
          letterSpacing: '0.46px',
          padding: '4px 12px',
          borderRadius: '16px',
        },
        textSizeLarge: {
          fontSize: '15px',
          fontWeight: 600,
          lineHeight: '26px',
          letterSpacing: '0.46px',
          padding: '6px 16px',
          borderRadius: '8px',
        },
        sizeSmall: {
          padding: '4px 12px',
          borderRadius: '16px',
          fontSize: '13px',
          fontWeight: 600,
          lineHeight: '22px',
          letterSpacing: '0.46px',
        },
        sizeLarge: {
          '@media (max-width:599.95px)': {
            borderRadius: '8px',
          },
          padding: '8px 16px',
          borderRadius: '32px',
          fontSize: '15px',
          fontWeight: 600,
          lineHeight: '26px',
          letterSpacing: '0.46px',
        },
        iconSizeSmall: {
          fontSize: '20px',
        },
        iconSizeMedium: {
          fontSize: '24px',
        },
        iconSizeLarge: {
          fontSize: '35px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: {
          padding: '3px',
        },
        colorSecondary: {
          color: teceoGraySecondary,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          textTransform: 'lowercase',
          color: teceoGraySecondary,
          borderColor: teceoGraySecondary,
        },
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        color: 'default',
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          textTransform: 'lowercase',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td': {
            borderBottom: 0,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        stickyHeader: {
          backgroundColor: '#fff',
          textTransform: 'lowercase',
        },
        head: {
          fontSize: '0.875rem',
          color: teceoGraySecondary,
          textTransform: 'lowercase',
        },
        body: {
          '& a': {
            textDecoration: 'none',
            color: '#242424',
          },
          '&:hover a': {
            textDecoration: 'none',
            cursor: 'pointer',
            color: teceoOrange,
          },
          '&:active a': {
            textDecoration: 'none',
          },
        },
        sizeSmall: {
          paddingTop: '4px',
          paddingBottom: '4px',
          paddingLeft: '12px',
          paddingRight: '12px',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          minHeight: '32px',
          '& a': {
            textDecoration: 'none',
            color: '#242424',
          },
          '&:hover a': {
            textDecoration: 'none',
            cursor: 'pointer',
            color: teceoOrange,
          },
          '&:active a': {
            textDecoration: 'none',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08) !important',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '32px !important',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          textTransform: 'lowercase',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: 'auto',
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        textColor: 'inherit',
        indicatorColor: 'secondary',
      },
      styleOverrides: {
        root: {
          paddingTop: 0,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          opacity: 0.7,
          maxWidth: '264px',
          marginRight: '24px',
          minWidth: 'auto !important',
          textTransform: 'lowercase',
          fontSize: '1rem',
          '&.Mui-selected': {
            fontWeight: 600,
            color: '#FF703D',
            blue: {
              '50': '#e3f2fd',
              '100': '#bbdefb',
              '200': '#90caf9',
              '300': '#64b5f6',
              '400': '#42a5f5',
              '500': '#2196f3',
              '600': '#1e88e5',
              '700': '#1976d2',
              '800': '#1565c0',
              '900': '#0d47a1',
              A100: '#82b1ff',
              A200: '#448aff',
              A400: '#2979ff',
              A700: '#2962ff',
            },
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          wordBreak: 'break-word',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 16,
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          ...(ownerState.orientation === 'vertical' &&
            ownerState.variant === 'middle' && {
              marginLeft: theme.spacing(2),
              marginRight: theme.spacing(2),
            }),
          backgroundColor: 'unset !important',
          borderBottomWidth: '0.5px',
        }),
      },
    },
    MuiRadio: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiSwitch: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        groupLabel: {
          lineHeight: '24px',
        },
        option: {
          '&[aria-selected="true"]': {
            backgroundColor: `${defaultTheme.palette.action.hover} !important`,
          },
        },
        listbox: {
          '& .MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: `${defaultTheme.palette.action.hover} !important`,
          },
          '& .MuiAutocomplete-option[role="option"][aria-selected="false"]:hover': {
            backgroundColor: defaultTheme.palette.action.hover,
          },
        },
        popupIndicator: {
          '& .MuiSvgIcon-root': {
            color: teceoGraySecondary,
          },
        },
      },
    },
    MuiDatePicker: {
      defaultProps: {
        slotProps: {
          actionBar: {
            sx: {
              padding: '8px',
            },
          },
        },
      },
    },
    MuiDateTimePicker: {
      defaultProps: {
        slotProps: {
          actionBar: {
            sx: {
              padding: '8px',
            },
          },
        },
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        root: ({ theme }) => ({
          '& .MuiPickersArrowSwitcher-leftArrowIcon, & .MuiPickersArrowSwitcher-rightArrowIcon': {
            color: theme.palette.action.active,
          },
        }),
      },
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        switchViewIcon: ({ theme }) => ({
          color: theme.palette.action.active,
        }),
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
        },
      },
    },
    MuiTreeItem: {
      styleOverrides: {
        content: {
          padding: '2px 8px',
        },
      },
    },
  },
  transitions: {
    duration: {
      standard: 100,
    },
  },
  palette: {
    text: {
      primary: teceoGrayPrimary,
      secondary: teceoGraySecondary,
      disabled: teceoTextDisabled,
    },
    mode: 'light',
    grey: {
      '50': '#fafafa',
      '100': '#f5f5f5',
      '200': '#eeeeee',
      '300': '#e0e0e0',
      '400': '#bdbdbd',
      '500': '#9e9e9e',
      '600': '#757575',
      '700': '#616161',
      '800': '#424242',
      '900': '#212121',
      A100: '#f5f5f5',
      A200: '#eeeeee',
      A400: '#bdbdbd',
      A700: '#616161',
    },
    secondary: {
      main: teceoSecondaryMain,
      light: teceoSecondaryLight,
      dark: teceoSecondaryDark,
      contrastText: teceoSecondaryContrast,
    },
    primary: {
      main: teceoPrimaryMain,
      light: teceoPrimaryLight,
      dark: teceoPrimaryDark,
      contrastText: teceoPrimaryContrast,
    },
    action: {
      active: '#97999B',
    },
    error: {
      main: '#D32F2F',
      dark: '#C62828',
      light: '#EF5350',
    },
    warning: {
      main: '#ED6C02',
      dark: '#E65100',
      light: '#FF9800',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#0288D1',
      dark: '#01579B',
      light: '#03A9F4',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#2E7D32',
      dark: '#1B5E20',
      light: '#4CAF50',
      contrastText: '#FFFFFF',
    },
    background: {
      default: teceoGrayBackground,
      paper: teceoPaperElevation0,
    },
  },
} satisfies ThemeOptions);

const theme = createTheme(mergedTheme);

export default theme;
